export default __webpack_public_path__ + "static/media/0063.b36ee37a.jpg";